import React from 'react'
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers'
import { DigitalClock } from '@mui/x-date-pickers/DigitalClock'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { IGeneralInfo } from '../../../types/app'

interface DeliverySchedulerProps {
  date: Date | null
  setDate: (value: Date | null) => void
  time: Date | null
  setTime: (value: Date | null) => void
  allHours: boolean
  nearestValidTime: Date
  generalInfo: IGeneralInfo
  isMobile: boolean
  t: (key: string) => string
}

const clockSx = {
  maxHeight: 220,
  '.MuiDigitalClock-list': { padding: '6px' },
  '.MuiDigitalClock-item': {
    margin: '2px 0',
    borderRadius: '12px',
    justifyContent: 'center',
    fontFamily: 'inherit',
    fontWeight: 800,
    fontSize: '15px',
    transition: 'background-color 0.2s ease, transform 0.2s ease',
    '&:hover': { backgroundColor: 'rgba(var(--color-primary-rgb), 0.08)' },
    '&.Mui-selected': {
      backgroundColor: 'var(--color-primary)',
      color: '#fff',
      '&:hover': { backgroundColor: 'var(--color-primary-hover)' },
    },
  },
}

const DeliveryScheduler: React.FC<DeliverySchedulerProps> = ({
  date,
  setDate,
  time,
  setTime,
  allHours,
  nearestValidTime,
  generalInfo,
}) => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <div className='checkout-page__schedule'>
      <MobileDatePicker
        views={['month', 'day']}
        minDate={new Date()}
        defaultValue={new Date()}
        value={date}
        timezone='Europe/Chisinau'
        onChange={setDate}
        slotProps={{
          textField: {
            variant: 'outlined',
            fullWidth: true,
            sx: {
              '.MuiOutlinedInput-root': {
                borderRadius: '16px',
                background: '#fbf4ee',
                fontFamily: 'inherit',
                fontWeight: 800,
                fontSize: '16px',
              },
              '.MuiOutlinedInput-notchedOutline': {
                border: '1.5px solid rgba(36, 23, 26, 0.08) !important',
              },
              '.Mui-focused .MuiOutlinedInput-notchedOutline': {
                border: '2px solid var(--color-primary) !important',
              },
              'label.Mui-focused': { color: 'var(--color-primary)' },
            },
          },
          day: {
            sx: {
              fontWeight: 700,
              '&.MuiPickersDay-root.Mui-selected': {
                backgroundColor: 'var(--color-primary)',
              },
            },
          },
          actionBar: {
            sx: { '.MuiButton-root': { color: 'var(--color-primary)', fontWeight: 800 } },
          },
        }}
      />
      <div className='checkout-page__clock'>
        {allHours ? (
          <DigitalClock
            timeStep={15}
            skipDisabled
            shouldDisableTime={() => false}
            timezone='Europe/Chisinau'
            sx={clockSx}
            minTime={
              new Date(0, 0, 0, Number(generalInfo?.minTime.split(':')[0]))
            }
            maxTime={
              new Date(0, 0, 0, Number(generalInfo?.maxTime.split(':')[0]))
            }
            ampm={false}
            value={time}
            onChange={setTime}
          />
        ) : (
          <DigitalClock
            timeStep={15}
            skipDisabled
            timezone='Europe/Chisinau'
            shouldDisableTime={() => false}
            sx={clockSx}
            minTime={nearestValidTime}
            maxTime={
              new Date(0, 0, 0, Number(generalInfo?.maxTime.split(':')[0]))
            }
            ampm={false}
            value={time}
            onChange={setTime}
          />
        )}
      </div>
    </div>
  </LocalizationProvider>
)

export default DeliveryScheduler
